import { render, staticRenderFns } from "./examsc.vue?vue&type=template&id=ed7510e8&scoped=true&"
import script from "./examsc.vue?vue&type=script&lang=js&"
export * from "./examsc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed7510e8",
  null
  
)

export default component.exports